module.exports = __webpack_public_path__ + "static/media/provozovna (3).7ca7e303.png";